import { createSlice } from "@reduxjs/toolkit";
import { PAGE_SIZES } from "../../../constants";

const initialState: any = {
  list: {
    total: 0,
    data: null,
    loading: null,
    success: null,
    error: null,
    filters: {
      selectedPage: 1,
      selectedPageSize: PAGE_SIZES[0],
      selectedDate: "",
    },
  },
  details: {
    data: null,
    loading: null,
    success: null,
    error: null,
  },
};

const invitation = createSlice({
  name: "invitation",
  initialState,
  reducers: {
    setInvitationListLoading: (state, action) => {
      state.list = {
        ...state.list,
        loading: action.payload,
      };
    },
    setInvitationListData: (state, action) => {
      state.list = {
        ...state.list,
        data: action.payload.data,
        total: action.payload.total,
        loading: false,
        error: "",
        success: true,
        filters: {
          ...state.list.filters,
          ...action.payload.filters,
        },
      };
    },
    setInvitationListError: (state, action) => {
      state.list = {
        ...state.list,
        total: 0,
        data: null,
        loading: false,
        success: false,
        error: action.payload,
      };
    },
    setInvitationDetailsLoading: (state, action) => {
      state.details = {
        ...state.details,
        loading: action.payload,
      };
    },
    setInvitationDetailsData: (state, action) => {
      state.details = {
        ...state.details,
        data: action.payload,
        success: true,
      };
    },
    setInvitationDetailsError: (state, action) => {
      state.details = {
        ...state.details,
        data: null,
        success: false,
        error: action.payload,
      };
    },
    resetInvitationDetails: (state) => {
      state.details = {
        data: null,
        loading: null,
        success: null,
        error: null,
      };
    },
  },
});

export const {
  setInvitationListLoading,
  setInvitationListData,
  setInvitationListError,
  setInvitationDetailsLoading,
  setInvitationDetailsData,
  setInvitationDetailsError,
  resetInvitationDetails,
} = invitation.actions;

export default invitation.reducer;
